import { FC, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { LeaseTabs, LeaseTabKey } from './LeaseTabs'
import LeaseItem from './LeaseItem'
import authService from '../../../services/authService'
import { InProgressLeaseApplication } from '@/types/management.types'

export const MyLeasesContent: FC = () => {
  const navigate = useNavigate()
  const [activeTab, setActiveTab] = useState<LeaseTabKey>('activos')
  const [leases, setLeases] = useState<InProgressLeaseApplication[]>([])
  const [rejectedLeases, setRejectedLeases] = useState<
    InProgressLeaseApplication[]
  >([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    // Solo "Activos" y "Rechazados" tienen endpoint por ahora —
    // "Terminados" queda como placeholder hasta que exista uno.
    if (activeTab !== 'activos') return

    let cancelled = false
    const load = async () => {
      setIsLoading(true)
      try {
        const data = await authService.getInProgressCreditApplications()
        if (!cancelled) setLeases(data)
      } finally {
        if (!cancelled) setIsLoading(false)
      }
    }
    load()

    return () => {
      cancelled = true
    }
  }, [activeTab])

  useEffect(() => {
    if (activeTab !== 'rechazados') return

    let cancelled = false
    const load = async () => {
      setIsLoading(true)
      try {
        const data = await authService.getRejectedCreditApplications()
        if (!cancelled) setRejectedLeases(data)
      } finally {
        if (!cancelled) setIsLoading(false)
      }
    }
    load()

    return () => {
      cancelled = true
    }
  }, [activeTab])

  return (
    <>
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl font-bold text-gray-900">
          Mis arrendamientos
        </h2>
        <button
          type="button"
          onClick={() => navigate('/mis-arrendamientos/nuevo')}
          className="bg-olr-primary hover:bg-olr-primary-hover text-white text-sm font-semibold rounded-full px-5 py-2.5 transition-colors"
        >
          Solicitar nuevo arrendamiento
        </button>
      </div>

      <LeaseTabs active={activeTab} onChange={setActiveTab} />

      {activeTab === 'terminados' ? (
        // No hay endpoint todavía para arrendamientos terminados.
        <div className="bg-white border border-olr-grey-2 rounded-lg p-12 text-center text-olr-body">
          Próximamente
        </div>
      ) : isLoading ? (
        <div className="bg-white border border-olr-grey-2 rounded-lg p-12 text-center text-olr-body">
          Cargando arrendamientos...
        </div>
      ) : activeTab === 'rechazados' ? (
        rejectedLeases.length === 0 ? (
          <div className="bg-white border border-olr-grey-2 rounded-lg p-12 text-center text-olr-body">
            No tienes arrendamientos rechazados.
          </div>
        ) : (
          rejectedLeases.map((lease, index) => (
            <LeaseItem
              key={lease.id}
              numero={index + 1}
              marca={lease.cotizacion.request_data.brand}
              modelo={lease.cotizacion.request_data.year}
              valorFactura={lease.cotizacion.request_data.valor_factura}
              onViewDetails={() =>
                navigate(`/mis-arrendamientos/${lease.id}`, {
                  state: { lease },
                })
              }
            />
          ))
        )
      ) : leases.length === 0 ? (
        <div className="bg-white border border-olr-grey-2 rounded-lg p-12 text-center text-olr-body">
          No tienes arrendamientos activos.
        </div>
      ) : (
        leases.map((lease, index) => (
          <LeaseItem
            key={lease.id}
            numero={index + 1}
            marca={lease.cotizacion.request_data.brand}
            modelo={lease.cotizacion.request_data.year}
            valorFactura={lease.cotizacion.request_data.valor_factura}
            onViewDetails={() =>
              navigate(`/mis-arrendamientos/${lease.id}`, {
                state: { lease },
              })
            }
          />
        ))
      )}
    </>
  )
}

export default MyLeasesContent
